import { render, staticRenderFns } from "./amount-with-currency.vue?vue&type=template&id=ef49ded6&scoped=true"
import script from "./amount-with-currency.vue?vue&type=script&lang=ts"
export * from "./amount-with-currency.vue?vue&type=script&lang=ts"
import style0 from "./amount-with-currency.vue?vue&type=style&index=0&id=ef49ded6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef49ded6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef49ded6')) {
      api.createRecord('ef49ded6', component.options)
    } else {
      api.reload('ef49ded6', component.options)
    }
    module.hot.accept("./amount-with-currency.vue?vue&type=template&id=ef49ded6&scoped=true", function () {
      api.rerender('ef49ded6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/amount-with-currency/amount-with-currency.vue"
export default component.exports